import { Box, Flex, ListItem, Text, useMediaQuery } from '@chakra-ui/react';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { H2 } from '@/components/Heading';
import { NextImage } from '@/components/Image/NextImage';
import { GoToLink } from '@/components/UI/Links/GoToLink';
import NavLink from '@/components/UI/Links/NavLink';

import breakpoints from '@/../themes/betterstyle-theme/breakpoints';
import { PostItemProps } from '@/models/props/PostItemProps';

function PostItemCard(props: PostItemProps) {
    const { title, shortDescription, url, imageUrl, imageAlt } = props;
    const [isDesktop] = useMediaQuery(`(min-width: ${breakpoints.lg})`, {
        ssr: true,
        fallback: true
    });
    const [desktop, setDesktop]: [
        boolean | undefined,
        Dispatch<SetStateAction<boolean | undefined>>
    ] = useState();

    useEffect(() => {
        setDesktop(isDesktop);
    }, [isDesktop]);

    return (
        <Flex as={ListItem}>
            <Box
                as="article"
                display="flex"
                borderRadius="2xl"
                flexDirection="column"
                padding={0}
                overflow="hidden"
                bgColor="grey.100"
                w="100%"
            >
                <Box pos="relative" h={desktop ? 60 : 'auto'} overflow="hidden">
                    {imageUrl && (
                        <NextImage
                            src={imageUrl}
                            width={desktop ? 500 : 560}
                            height={desktop ? 450 : 320}
                            alt={imageAlt ?? title}
                            style={{ objectFit: 'cover' }}
                        />
                    )}
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    pt={{ lg: 8, base: 6 }}
                    px={{ lg: 8, md: 6, base: 4 }}
                    pb={6}
                >
                    <H2 size="h4" mb={{ sm: '8px', base: 0 }}>
                        <NavLink href={url}>{title}</NavLink>
                    </H2>
                    <Text mb={6} dangerouslySetInnerHTML={{ __html: shortDescription }} />
                    <GoToLink href={url} />
                </Box>
            </Box>
        </Flex>
    );
}

export default PostItemCard;
